import React from 'react';
import styled from "styled-components";
import { SingleVehicleType } from '../../Components/Types';

type SplashProps = {
    vehicle: SingleVehicleType;
}

const Container = styled.div`
    background: #669965;
    background: var(--main-theme-gradient);
    display:flex;
    justify-content:center;
    @media (max-width: 1200px) {
        justify-content:space-between;
    }
`;

const TextContainer = styled.div`
    display:flex;
    align-items:center;
    width:30%;
    color: #fff;
    @media (max-width: 1200px) {
        width:50%;
        margin-left: 2em;
        margin-right: 2em;
    }
    @media (max-width: 1000px) {
        width:100%;
    }
`;
const HeaderText = styled.h2`
    font-family: Lato-Bold;
    font-size:1.8rem;
    margin-bottom: 1em;
`;
const BodyText = styled.p`
    font-size:0.9rem;
    line-height: 1.6em;
    margin-bottom: 1em;
`;
const Image = styled.img`
    width:50%;
    @media (max-width: 1000px) {
        display: none;
    }
`;
function Splash({ vehicle } : SplashProps) {

    return (
        <Container>
            <TextContainer>
                <div>
                    <HeaderText>{vehicle.name}</HeaderText>
                    <BodyText>{vehicle.description}</BodyText>
                </div>
            </TextContainer>
            <Image src="/images/motorhome/Motorhome-Web-Assets-06.png" />
        </Container>
    );
}
export default Splash;
